import { GET_REF, SET_REF } from "./type";

export const setRef = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: SET_REF,
      payload: payload,
    });
  } catch (error) {
    console.log(error, "error in setRef action");
  }
};

export const getRef = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_REF,
      payload: null,
    });
  } catch (error) {
    console.log(error, "error in getRef action");
  }
};
